import { Component, Inject } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import Swal from "sweetalert2";
import { IBillingShippingModel } from "../../../interfaces/LicenseModel";
import { AppLoaderComponent } from "../../../../services/app-loader/app-loader.component";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";
import { SmartCal360AssignCustomerFilterPipe } from "../pipes/smartcal360AssignCustomerPipe";
import { PagerService } from "../../../services/PagerService";

@Component({
    template:require('./assign-smartcal360n-customer.component.html'),
    styles:[require('./assign-smartcal360n-customer.component.css')],
    selector:'assign-smartcal360n-customer'
})
export class AssignSmartCal360NCustomerComponent{
    SelectedLicenseIdList;
    dialogTitle='Assign Customer';
    originalCustomerDetailList;
    customerDetailList;
    filteredCustomerDetailsList=[];
    errorMessage='';
    isLoading=false;
    SmartCal360NLicenseData;
    BillToList=[];
    searchCustomerName='';
    pager:any={};
    pagedItems: any[];
    currentSortColumn;
    currentSortOrder;
    public constructor(
        private licenseService:LicenseService,
        public dialogRef:MdDialogRef<AssignSmartCal360NCustomerComponent>,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        private filterPipe:SmartCal360AssignCustomerFilterPipe,
        private pagerService: PagerService,
        @Inject(MD_DIALOG_DATA) public dialogData
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedLicenseIdList=dialogData.SelectedLicensesId;
        this.SmartCal360NLicenseData=dialogData.SmartCal360NLicenseData;
        this.getAllCustomersDetails();
    }
    getAllCustomersDetails(){
        this.isLoading=true;
        this.licenseService.getAllCustomersDetail().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalCustomerDetailList=data.DataObject;
                this.customerDetailList=[...this.originalCustomerDetailList]
                this.buildSearchArray();
                this.setPage(1);
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    buildSearchArray() {
        const BillToArray = this.customerDetailList.map(item => item.BillToName)
        this.BillToList = Array.from(new Set(BillToArray)).sort();
    }
    search(){
        this.setPage(1);
    }
    clear(){
        this.searchCustomerName='';
        this.setPage(1);
    }
    setPage(page: number) {
        this.customerDetailList=[...this.originalCustomerDetailList];
        this.applySort();
        this.filteredCustomerDetailsList = this.filterPipe.transform(this.customerDetailList, this.searchCustomerName);
        this.pager = this.pagerService.getPager(this.filteredCustomerDetailsList.length, page, 5);
        this.pagedItems = this.filteredCustomerDetailsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage = (this.pagedItems.length == 0) ? "No records found." : "";
    }
    assignCustomer(row){
        Swal.fire({
            title:'Assign Customer',
            text:'Are you sure you want to assign selected license to this customer?',
            showCloseButton:true,
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonColor:'#FFCA28',
            confirmButtonText:'Yes',
            cancelButtonText:'No'
        }).then((result)=>{
            if(result.isConfirmed){
                this.appLoader.open();
                this.licenseService.addBillingShippingDetail(row).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        let model={
                            SmartCal360NLicenseIdList:this.SelectedLicenseIdList,
                            CustomerId:data.DataObject.CustomerId,
                            UpdatedBy:Number(localStorage.getItem('userid'))
                        }
                        this.licenseService.updateSmarCal360NLicense(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.SmartCal360NLicenseData=data.DataObject;
                            }
                            this.appLoader.close();
                            this.dialogRef.close(this.SmartCal360NLicenseData)
                        })
                    }
                })
            }
        })
    }
    onCancel(){
        this.dialogRef.close(this.SmartCal360NLicenseData)
    }
    onSortChange(event){
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    }
    applySort(){
        if(!this.currentSortColumn || !this.currentSortOrder) return;
        this.customerDetailList=this.customerDetailList.sort((a,b)=>
            {
                if(this.currentSortOrder==='asc'){
                    a[this.currentSortColumn]=a[this.currentSortColumn] || '';
                    return a[this.currentSortColumn].localeCompare(b[this.currentSortColumn])
                }
                else if (this.currentSortOrder==='desc'){
                    b[this.currentSortColumn]=b[this.currentSortColumn] || '';
                    return b[this.currentSortColumn].localeCompare(a[this.currentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartcal360/assign-smartcal360n-customer/assign-smartcal360n-customer.component.ts